<div class="d-flex flex-row">
  <div>
    <app-dashboard-side-menu></app-dashboard-side-menu>
  </div>
  <div class="p-content d-flex flex-column w-100">
    <app-dashboard-top-menu></app-dashboard-top-menu>
    @if (loading) {
      <div class="loading-animation">
        <app-loading></app-loading>
      </div>
    } @else {
      <div class="content">
        <form [formGroup]="myForm" (ngSubmit)="alterProd()">
          <span class="title">Editar produto</span>
          <div class="green-div">
            <div class="row-double">
              <div>
                <!-- Selecionar produto -->
                <div class="upload-template">
                  <span class="text-description">Selecione o produto</span>
                  <app-search-input-products [isMultiple]="false" [plist]="plist" [searchControl]="myControl"
                    [selectProducts]="selectProducts" [selectedItems]="selectedItens">
                  </app-search-input-products>
                </div>
                <!-- Upload ficha técnica (.PDF) -->
                <div class="upload-ft">
                  <span class="text-description">Upload ficha técnica (.PDF)</span>
                  <input type="file" [accept]="fileTypeUpdt" (change)="onFileChange($event, technicalFileUpdt)">
                </div>
              </div>
              <div>
                <!-- Upload de Imagem (550x550px) -->
                <div class="upload-img">
                  <span class="text-description">Upload de Imagem (550x550px)</span>
                  <input type="file" [accept]="imgTypeUpdt" (change)="onFileChange($event, imgFileUpdt)">
                </div>
                <!-- Upload bula (.PDF) -->
                <div class="upload-ft">
                  <span class="text-description">Upload bula (.PDF)</span>
                  <input type="file" [accept]="fileTypeUpdt" (change)="onFileChange($event, flyerFileUpdt)">
                </div>
              </div>
            </div>
          </div>
          <button class="btn-next btn-processar d-flex" type="submit">
            <span>Editar produto</span>
            <img src="../../../assets/Icons/icon-done.png" alt="done" />
          </button>
        </form>
      </div>
    }
    <app-footer></app-footer>
  </div>
</div>